import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn:
    import.meta.env.VITE_SENTRY_DSN ||
    "https://5f091321280003e01afe05b7b6d4cf50@o4511248735207424.ingest.de.sentry.io/4511248737370192",
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  sendDefaultPii: true,
  tracesSampleRate: 0.2,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  ignoreErrors: [
    "NetworkError",
    "Failed to fetch",
    "Load failed",
    "ResizeObserver loop limit exceeded",
  ],
});

createRoot(document.getElementById("root")!).render(<App />);
